<template>
  <v-container grid-list-md>
    <v-layout
      row
      wrap
    >
      <v-flex xs12>
        <v-layout
          row
          wrap
        >
          <v-flex xs12>
            <TaskListFilter />

            <v-divider class="mt-0 mb-2" />
          </v-flex>

          <v-flex
            xs12
            md6
          >
            <TaskList
              :subheader="'My Tasks'"
              :empty-message="'You have no tasks assigned. Tasks can be claimed from the pool'"
              :tasks="listMyTasks"
            />
          </v-flex>
          <v-flex
            xs12
            md6
          >
            <TaskList
              :subheader="'Task Pool'"
              :empty-message="'The task pool is empty'"
              :tasks="listTaskPool"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import { mapGetters } from 'vuex'
  import TaskList from '@/components/Task/TaskList.vue'
  import TaskListFilter from '@/components/Task/TaskListFilter.vue'


  export default {
    components: {
      TaskList,
      TaskListFilter
    },
    computed: {
      ...mapGetters([
        'getUser',
        'myTasks',
        'taskPool'
      ]),
      listTaskPool() {
        return this.taskPool
      },
      listMyTasks() {
        return this.myTasks
      }
    },
    watch: {
      getUser() {
        /**
         * The tasks are dependant on the User Record being loaded.
         * We must watch the User Record to detect when it has changed and
         * trigger our listeners again
         */
        this.init()
      }
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        this.$store.dispatch('initTasks')
      }
    }
  }
</script>
